export default class Preloader {
  static hide(selector = '.preloader-wrapper', autoRemove = false) {
    $(selector).addClass('loaded');
    if (autoRemove) Preloader.remove();
  }

  static show(selector = '.preloader-wrapper') {
    $(selector).removeClass('loaded');
  }

  static remove(selector = '.preloader-wrapper', timeout = 3000) {
    setTimeout(() => $(selector).remove(), timeout);
  }
}



// WEBPACK FOOTER //
// local_static/templates/quadro_de_medalhas/2018/assets/scripts/components/ge-preloader.js